<div class="user-selection" *ngIf="state">
  <div class="user-selection__area">
    <div class="user-selection__area--header">
      <img src="assets/svg/login/rework/george_logo.svg" alt="logo-george" />
      <h2>{{ 'authPage.userSelection.header' | translate }}</h2>
    </div>
    <div class="users-list" *ngIf="state.userInfos">
      <div class="user" *ngFor="let user of state.userInfos; let i = index">
        <gla-cell
          [topLine]="user.entityType === 'LEGAL_ENTITY' ? 'Business' : 'Personal'"
          [value]="user.profileName"
          [label]="(user.username ? user.username + ' | ' : '') + (user.alias ? user.alias : '')"
          [bottomBorder]="true"
          (click)="postSelectEntity(i)"
        >
          <img
            [src]="'assets/svg/login/rework/' + (user.entityType === 'LEGAL_ENTITY' ? 'business' : 'person') + '.svg'"
            alt="user-image"
            leftSide
          />
          <img src="assets/svg/login/rework/carret-right.svg" class="carret-right" alt="carret-right" rightSide />
        </gla-cell>
      </div>
    </div>
  </div>
</div>
